import React, { useState} from 'react'
import moment from 'moment'

import useSWR, { useSWRConfig } from 'swr'
import { Table, Button, Form } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'


import ApiResponseErrorView from '../../api/ApiResponseErrorView.js'
import BigTable from '../../components/BigTable.js'
import ResourceLoader from '../../ResourceLoader.js'
import { resourceHandler } from '../../api/resource.js'
import { requestHandler } from '../../api/request.js'

import '../../BigButton.css'

function CommentHistory(props)
{
    let data = [];
    let datetime_lookup = { }
    for(let i = 0; i < props.data.notes.length; i++)
    {
        let user = props.data.notes[i].user
        for(let j = 0; j < props.data.superusers.length; j++)
        {
            if(props.data.superusers[j].id === user)
            {
                user = props.data.superusers[j].username
                break;
            }
        }
        datetime_lookup[props.data.notes[i].date_created] =
            moment(props.data.notes[i].date_created, 'MMMM Do YYYY - hh:mm:ss A').valueOf();

        let obj = {
            date: moment(props.data.notes[i].date_created + 'Z').format(
                'MMMM Do YYYY - hh:mm:ss A'),
            user: user,
            note: props.data.notes[i].comment
        };

        data.push(obj);
    }

    let headers = [
        { title: "Date", field: "date", width: 3000, minWidth: 200,
            sortable: true, searchable: true, customSort: (a, b) =>
            {
                return datetime_lookup[a] - datetime_lookup[b]
            } },
        { title: "User", field: "user", width: 3000, minWidth: 200,
            sortable: true, searchable: true },
        { title: "Note", field: "note", width: 3000, minWidth: 600,
            sortable: true, searchable: true },
    ];


    return <BigTable
        headers={headers}
        data={data}
        defaultSort={{
            'key': 'column-0',
            'order': 'desc'
        }}
        title={'Edit History'}
    />
}

function CameraEditForm(props)
{
    const { data: notes, error: note_error } = useSWR(
        resourceHandler.list_camera_notes(props.data.camera.id).url,
        requestHandler.cacheFetcher);

    let loaded = (notes);
    let error = !(!note_error);

    let date = null
    if(props.data.camera.invoice_date !== null)
    {
        let dstring = moment(props.data.camera.invoice_date+'Z').format(
            'MMMM D, YYYY');
        date = new Date(dstring)
    }
    const [serialNumber, setSerialNumber] = useState(props.data.camera.serial_no)
    const [mountSide, setMountSide] = useState(props.data.camera.side)
    const [mountPosition, setMountPosition] = useState(props.data.camera.location)
    const [cameraManufacturer, setCameraManufacturer] = useState(props.data.camera.manufacturer)
    const [cameraModel, setCameraModel] = useState(props.data.camera.model)
    const [productId, setProductId] = useState(props.data.camera.product_id)
    const [macAddress, setMacAddress] = useState(props.data.camera.mac_address)
    const [firmwareVersion, setFirmwareVersion] = useState(props.data.camera.firmware_version)
    const [invoiceNo, setInvoiceNo] = useState(props.data.camera.invoice_no)
    const [invoiceDate, setInvoiceDate] = useState(date);
    const [cameraVendor, setCameraVendor] = useState(props.data.camera.vendor);
    const [isBroken, setIsBroken] = useState(props.data.camera.is_broken)
    const [truckAssignment, setTruckAssignment] = useState(props.data.camera.truck)
    const [additionalComments, setAdditionalComments] = useState('')

    /*
     * State update callbacks
     */
    const onSerialChange = (event) =>
    {
        setSerialNumber(event.target.value);
    };
    const onMountSideChange = (event) =>
    {
        setMountSide(event.target.value);
    }
    const onMountPositionChange = (event) =>
    {
        setMountPosition(event.target.value)
    }
    const onCameraManufacturerChange = (event) =>
    {
        setCameraManufacturer(event.target.value)
    }
    const onCameraModelChange = (event) =>
    {
        setCameraModel(event.target.value)
    }
    const onProductIdChange = (event) =>
    {
        setProductId(event.target.value)
    }
    const onMacAddressChange = (event) =>
    {
        setMacAddress(event.target.value)
    }
    const onFirmwareVersionChange = (event) =>
    {
        setFirmwareVersion(event.target.value)
    }
    const onInvoiceNoChange = (event) =>
    {
        setInvoiceNo(event.target.value)
    }
    const onCameraVendorChange = (event) =>
    {
        setCameraVendor(event.target.value);
    }
    const onIsBrokenChange = (event) =>
    {
        setIsBroken(event.target.value)
    }
    const onTruckAssignment = (event) =>
    {
        setTruckAssignment(event.target.value);
    };
    const onAdditionalComments = (event) =>
    {
        setAdditionalComments(event.target.value);
    };
    const onEditCamera = (event) =>
    {
        /*
         * Data checks
         */
        if(!parseInt(serialNumber))
        {
            alert('Serial number needs to be numeric');
            return;
        }
        if(serialNumber.length === 0)
        {
            alert('Serial number needs to be non zero');
            return;
        }
        if(serialNumber !== props.data.camera.serial_no)
        {
            for(let i = 0; i < props.data.cameras.length; i++)
            {
                if(props.data.cameras[i].serial_no === serialNumber)
                {
                    alert('The serial number you entered is already assigned to a camera!');
                    return;
                }
            }
        }

        let edit_post_obj = {
            serial_no: serialNumber,
            manufacturer: cameraManufacturer,
            model: cameraModel,
            product_id: productId,
            mac_address: macAddress,
            firmware_version: firmwareVersion,
            invoice_no: invoiceNo,
            invoice_date: invoiceDate,
            vendor: cameraVendor,
            side: mountSide,
            location: mountPosition,
            truck: truckAssignment,
            is_broken: isBroken
        }

        if(edit_post_obj.truck === '')
        {
            edit_post_obj.truck = null
        }
        if(edit_post_obj.side === '')
        {
            edit_post_obj.side = null
        }
        if(edit_post_obj.location === '')
        {
            edit_post_obj.location = null
        }

        let comment_post_obj = {
            camera: props.data.camera.id,
            comment: additionalComments,
            user: props.data.company_admin.id
        }


        props.onSubmit(edit_post_obj, comment_post_obj)
    };

    const truckOptionList = () =>
    {
        let unassigned_truck_list = []

        for(let i = 0; i < props.data.trucks.length; i++)
        {
            /*
             * Multiple cameras can go to a truck
             */
            unassigned_truck_list.push(props.data.trucks[i]);
        }

        unassigned_truck_list = unassigned_truck_list.sort((a,b) => {
            return a.limntech_name.localeCompare(b.limntech_name)
        })

        return unassigned_truck_list.map(
            (truck, index) =>
        {
            return (
                <option value={truck.id}>
                    {truck.limntech_name}
                </option>
            );
        });
    }

    if(error)
    {
        return (
            <ApiResponseErrorView
                error={error}
            />
        );
    }
    else if(loaded)
    {
        let data = props.data;
        data['notes'] = notes;

        return (
            <div>
            <h1> Edit Camera </h1>
            <Form.Group>
                <Table hover>
                    <tbody>
                        <tr>
                            <td> Serial Number </td>
                            <td>
                                <Form.Control
                                    type="input"
                                    onChange={onSerialChange}
                                    value={serialNumber}
                                    placeholder={"enter board's serial number"}
                                    size={"lg"} />
                            </td>
                        </tr>
                        <tr>
                            <td> Mounting Side </td>
                            <td>
                                <Form.Control
                                    as="select"
                                    onChange={onMountSideChange}
                                    value={mountSide}
                                    size={"lg"}>
                                    <option value={''}> Unassigned </option>
                                    <option value={'left'}> Left </option>
                                    <option value={'right'}> Right </option>
                                </Form.Control>
                            </td>
                        </tr>
                        <tr>
                            <td> Mounting Position </td>
                            <td>
                                <Form.Control
                                    as="select"
                                    onChange={onMountPositionChange}
                                    value={mountPosition}
                                    size={"lg"}>
                                    <option value={''}> Unassigned or N/A </option>
                                    <option value={'front'}> Front </option>
                                    <option value={'rear'}> Rear </option>
                                </Form.Control>
                            </td>
                        </tr>
                        <tr>
                            <td> Manufacturer </td>
                            <td>
                                <Form.Control
                                    type="input"
                                    onChange={onCameraManufacturerChange}
                                    value={cameraManufacturer}
                                    placeholder={"enter camera's manufacturer e.g. Basler"}
                                    size={"lg"} />
                            </td>
                        </tr>
                        <tr>
                            <td> Model </td>
                            <td>
                                <Form.Control
                                    type="input"
                                    onChange={onCameraModelChange}
                                    value={cameraModel}
                                    placeholder={"enter camera's model e.g. a2A1920-51gcBAS"}
                                    size={"lg"} />
                            </td>
                        </tr>
                        <tr>
                            <td> Product ID </td>
                            <td>
                                <Form.Control
                                    type="input"
                                    onChange={onProductIdChange}
                                    value={productId}
                                    placeholder={"enter camera's product id e.g. 107823 – 21"}
                                    size={"lg"} />
                            </td>
                        </tr>
                        <tr>
                            <td> MAC Address </td>
                            <td>
                                <Form.Control
                                    type="input"
                                    onChange={onMacAddressChange}
                                    value={macAddress}
                                    placeholder={"enter camera's MAC Address e.g. 00:30:53:35:D0:40"}
                                    size={"lg"} />
                            </td>
                        </tr>
                        <tr>
                            <td> Firmware Version </td>
                            <td>
                                <Form.Control
                                    type="input"
                                    onChange={onFirmwareVersionChange}
                                    value={firmwareVersion}
                                    placeholder={"enter camera's firmware version e.g. p=vg3_imx392c_bas/s=r/v=2.0.3/i=5121.28/h=ba69dd2"}
                                    size={"lg"} />
                            </td>
                        </tr>
                        <tr>
                            <td> Invoice Number </td>
                            <td>
                                <Form.Control
                                    type="input"
                                    onChange={onInvoiceNoChange}
                                    value={invoiceNo}
                                    placeholder={"enter camera's invoice number"}
                                    size={"lg"} />
                            </td>
                        </tr>
                        <tr>
                            <td> Invoice Date </td>
                            <td> <DatePicker
                                wrapperClassName='date_picker'
                                className='form-control form-control-lg'
                                selected={invoiceDate}
                                onChange={(date) =>setInvoiceDate(date)}/> </td>
                        </tr>
                        <tr>
                            <td> Vendor </td>
                            <td>
                                <Form.Control
                                    type="input"
                                    onChange={onCameraVendorChange}
                                    value={cameraVendor}
                                    placeholder={"enter camera's vendor e.g. Basler"}
                                    size={"lg"} />
                            </td>
                        </tr>
                        <tr>
                            <td> Are there any known problems with this camera? </td>
                            <td>
                                <Form.Control
                                    as="select"
                                    onChange={onIsBrokenChange}
                                    value={isBroken}
                                    size={"lg"}>
                                    <option value={true}> Yes </option>
                                    <option value={false}> No </option>
                                </Form.Control>
                            </td>
                        </tr>
                        <tr>
                            <td> Truck Assignment </td>
                            <td>
                                <Form.Control
                                    as="select"
                                    onChange={onTruckAssignment}
                                    value={truckAssignment}
                                    size={"lg"}>
                                    <option value={''}> Unassigned </option>
                                    { truckOptionList() }
                                </Form.Control>
                            </td>
                        </tr>
                        <tr>
                            <td> Additional Comments </td>
                            <td>
                                <Form.Control
                                    type="input"
                                    onChange={onAdditionalComments}
                                    value={additionalComments}
                                    placeholder={"This field is optional"}
                                    size={"lg"} />
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Form.Group>
            <p>{'\n\n'}</p>
            <p><b> Note: Editing the hardware assignment in this form may invalidate the configuration file generated by the new truck setup survey </b></p>
            <CommentHistory data={data} />
            <p>{'\n\n'}</p>
            <Button
                variant="primary"
                className="BigButton"
                onClick={onEditCamera}>
                    { "Edit Camera" }
            </Button>
            <p>{'\n\n'}</p>
            </div>
        );
    }
    else
    {
        return <ResourceLoader />
    }
}

export default function CameraEdit(props)
{
    let { id } = useParams();
    const [apiError, setApiError] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [redirectToInventory, setRedirectToInventory] = useState(false);

    const { cache } = useSWRConfig()

    /*
     * Data Loading
     */
    const { data: company_admin, error: ca_error } = useSWR(
        resourceHandler.current_user().url, requestHandler.cacheFetcher);
    const { data: cameras, error: cameras_error } = useSWR(
        resourceHandler.list_cameras('').url, requestHandler.cacheFetcher);
    const { data: trucks, error: truck_error } = useSWR(
        resourceHandler.list_trucks('').url, requestHandler.cacheFetcher);
    const { data: superusers, error: superuser_error } = useSWR(
        resourceHandler.list_superusers().url, requestHandler.cacheFetcher);

    /*
     * Render Logic
     */
    let loaded = (company_admin && cameras && superusers && trucks);
    let error = !(!ca_error && !cameras_error && !superuser_error && !truck_error);

    const onRedirectInventory = () =>
    {
        /*
         * Since this is just internal use, I don't want to make the code more
         * complicated to update the cache on these changes. Lets just reload
         * the things we changed here
         */
        cache.delete(resourceHandler.list_trucks('').url)
        cache.delete(resourceHandler.list_cameras().url)
        setRedirectToInventory(true);
    }
    const onSubmit = (edit_put_obj, comment_post_obj) =>
    {
        const onError = () =>
        {
            setApiError(true);
        }

        const onSuccess = () =>
        {
            setSubmitSuccess(true);
        }
        const onEditSuccess = (response) =>
        {
            if(comment_post_obj.comment.length === 0)
            {
                onSuccess();
            }
            else
            {
                requestHandler.post(
                    resourceHandler.create_camera_note(),
                    comment_post_obj,
                    onSuccess,
                    onError);
            }
        }

        requestHandler.put(
            resourceHandler.edit_camera(comment_post_obj.camera),
            edit_put_obj,
            onEditSuccess,
            onError);
        setSubmitting(true)
    }

    if(error || apiError)
    {
        return (
            <ApiResponseErrorView
                error={error}
            />
        );
    }
    else if(redirectToInventory)
    {
        return ( <Navigate to="/inventory_management/"/>);
    }
    else if(submitSuccess)
    {
        return (
            <div>
                <h1> Camera Edit Success </h1>
                <p> Press the button below to return to inventory </p>
                <p> You may also navigate to any other page using the banner above </p>
                <Button
                    variant="primary"
                    className="BigButton"
                    onClick={onRedirectInventory}>
                        Inventory Management
                </Button>
            </div>
        );
    }
    else if(submitting)
    {
        return <ResourceLoader/>
    }
    else if(loaded)
    {
        let camera = null;
        for(let i = 0; i < cameras.length; i++)
        {
            if(cameras[i].id === id)
            {
                camera = cameras[i];
                break;
            }
        }

        if(camera)
        {
            let data = {
                camera: camera,
                cameras: cameras,
                company_admin: company_admin,
                superusers: superusers,
                trucks: trucks,
            };

            return <CameraEditForm data={data} onSubmit={onSubmit}/>
        }
        else
        {
            return (
                <div>
                <h1> Something went wrong! </h1>
                <p> We could not find a match in the database for the selected camera </p>
                </div>
            );
        }
    }
    else
    {
        return <ResourceLoader />
    }
}
